<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <div class="evaluation-athlete-show">
        <mobile-module-content *ngIf="!isLoading && !is401 && !is404" title="{{ evaluationAthlete ? evaluationAthlete['evaluation']?.title: 'Evaluations' | translate }}">
            <mat-card-header class="evaluation-athlete-status">
                <mat-card-subtitle>
                    <mat-chip-set>
                        <mat-chip *ngIf="evaluationAthlete"
                                  [ngClass]="evaluationAthlete.status === 'opened' ? 'mat-chip-accent' : ''">{{ evaluationAthlete.status??'' | translate }}
                        </mat-chip>
                    </mat-chip-set>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="evaluation-athlete-content mb-20" *ngIf="evaluationAthlete">
                <div class="evaluation-athlete-date mb-10">{{ 'EvaluationOf' | translate:{date: (evaluationAthlete.date|appDate:'mediumDate')} }}</div>
                <div class="evaluation-athlete-descriptions">{{ evaluationAthlete['evaluation']?.description }}</div>
            </mat-card-content>

            <div class="header">
                <evaluation-athlete-result *ngIf="evaluationAthlete else noEvaluation" [evaluationAthlete]="evaluationAthlete" [isDesktop]="this.isDesktop" [organization]="organization"></evaluation-athlete-result>
                <ng-template #noEvaluation>
                    <div class="evaluation-athlete-no-evaluation">
                        {{ 'EvaluationAthleteNoEvaluation'|translate }}
                    </div>
                </ng-template>
            </div>
            <div *ngIf="evaluationAthlete">
                <p class="note-title">{{ 'Evaluation_notes' | translate }}</p>
                <p class="note-content">{{ evaluationAthleteNotes.value }}</p>
            </div>
        </mobile-module-content>
    </div>

    <div>
        <ng-container>
            <main-action
                    *ngIf="!is401 && !is404 && evaluationAthlete && false && evaluationAthlete.status == 'opened'"
                    [title]="'Edit_Evaluation' | translate"
                    [icon]="'edit'"
                    [color]="'accent'"
                    [link]="'/' + organization.code + '/app/athletes/' + athleteUser.id +'/evaluations/' + evaluationAthlete.id + '/edit'"
            >
            </main-action>
        </ng-container>
    </div>
</mobile-page-content>

